"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Inview = /*#__PURE__*/function () {
  function Inview(component) {
    (0, _classCallCheck2["default"])(this, Inview);
    this.dom = {
      $component: component,
      $entries: Array.from(component.querySelectorAll('.js-inview-entry'))
    }, this.state = {
      inviewClass: 'is-inview',
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype,
      observer: false,
      observerConfig: {
        rootMargin: '-20%',
        threshold: 0.01
      }
    };
    this.mount();
  }

  (0, _createClass2["default"])(Inview, [{
    key: "mount",
    value: function mount() {
      var state = this.state;
      console.log('Inview : mount', this);

      if (!state.supportsIntersectionObserver) {
        this.setInview();
      } else {
        this.observe();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var state = this.state;
      console.log('Inview : unmount', this);
      this.unobserve();
    }
  }, {
    key: "observe",
    value: function observe() {
      var dom = this.dom,
          state = this.state;
      console.log('Inview : observe', this);
      state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
      dom.$entries.forEach(function (element) {
        return state.observer.observe(element);
      });
    }
  }, {
    key: "onIntersection",
    value: function onIntersection(entries) {
      var state = this.state;
      console.log('Media : onIntersection', this);
      entries.forEach(function (entry) {
        var inview = entry.intersectionRatio > 0;

        if (inview) {
          state.observer.unobserve(entry.target);
          entry.target.classList.add(state.inviewClass);
        }
      });
    }
  }, {
    key: "unobserve",
    value: function unobserve() {
      var dom = this.dom,
          state = this.state;
      dom.$entries.forEach(function (element) {
        return state.observer.observe(element);
      });
    }
  }, {
    key: "setInview",
    value: function setInview() {
      var dom = this.dom,
          state = this.state;
      console.log('Inview : setInview', this);
      dom.$entries.forEach(function (entry) {
        return entry.classList.add(state.inviewClass);
      });
    }
  }]);
  return Inview;
}();

exports["default"] = Inview;